import type { AppRouter } from "@repo/api/types";
import { createTRPCClient, type TRPCLink, loggerLink } from "@trpc/client";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import { apiBaseUrl, apiCredentials } from "./portfolio-host";
import { queryClient } from "./query";
import { createAppTransportLink } from "./trpc-links";

// Build links array conditionally based on environment
const links: TRPCLink<AppRouter>[] = [];

// Add logger link in development for debugging
if (import.meta.env.DEV) {
  links.push(
    loggerLink({
      enabled: (opts) =>
        (import.meta.env.DEV && typeof window !== "undefined") ||
        (opts.direction === "down" && opts.result instanceof Error),
    }),
  );
}

// Terminating transport: legacy-backed procedures unbatched, the rest batched
// (EPD-12126, see trpc-links.ts).
links.push(
  createAppTransportLink({
    // On the marketing-domain portfolio host the API lives on the app origin
    // and is called without credentials (EPD-10104).
    url: `${apiBaseUrl(import.meta.env.VITE_API_URL || "/api")}/trpc`,
    credentials: apiCredentials(),
    // Custom headers for request tracking
    headers() {
      return {
        "x-trpc-source": "react-app",
      };
    },
  }),
);

export const trpcClient = createTRPCClient<AppRouter>({ links });

export const api = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});
